import { z } from "zod"

export const HeaderSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  image: z.string(),
  created_at: z.coerce.number().nullable().optional(),
  updated_at: z.coerce.number().nullable().optional(),
  created_by: z.coerce.number().nullable().optional(),
  updated_by: z.coerce.number().nullable().optional(),
})

export const HeadersSchema = z.array(HeaderSchema)

export type Header = z.infer<typeof HeaderSchema>
export type Headers = z.infer<typeof HeadersSchema>
